import { Dialog, IconButton, Theme } from '@mui/material';

import { ReactComponent as CloseIcon } from 'assets/icons/CloseIcon.svg';

import { IModalProps } from './types';

import scssVariables from 'styles/sass-variables.module.scss';

const modalCloseIconStyles = {
  position: 'absolute',
  right: (theme: Theme) => theme.spacing(2),
  top: (theme: Theme) => theme.spacing(2),
  padding: 0.25,
};

export const Modal: React.FC<IModalProps> = ({ close, children, showCloseButton = true, ...rest }) => {
  return (
    <Dialog {...rest} fullWidth onClose={close} open>
      {showCloseButton && (
        <IconButton aria-label="close" onClick={close} sx={modalCloseIconStyles}>
          <CloseIcon color={scssVariables.text_grey} />
        </IconButton>
      )}

      {children}
    </Dialog>
  );
};
